import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { useOpQuery } from 'utils/customHooks/useOpQuery';
import { useSamlAppLogin } from 'utils/customHooks/useSamlAppLogin';
import { OpInfo, OpInfoProps } from 'new-components/DLS/OpInfo/OpInfo';
import { OpTextButton } from 'new-components/DLS/OpTextButton/OpTextButton';

import { RequestLicensesModal } from './RequestLicensesModal';

import './RequestLicensesInlineMessage.scss';

interface RequestLicensesInlineMessageProps {
  orgId: number;
  message: string;
  featureName: string;
  type: OpInfoProps['type'];
  // Falls back to the org's base package when not provided.
  packageId?: number;
}

export const RequestLicensesInlineMessage = ({
  orgId,
  message,
  featureName,
  type,
  packageId,
}: RequestLicensesInlineMessageProps) => {
  const { t } = useTranslation();

  const [modalOpen, setModalOpen] = useState(false);

  const { data: billingMode } = useOpQuery({
    apiEndpointName: 'describeOrg',
    parameters: [orgId],
    select: (heliumResponse) => heliumResponse.json.data.billingMode,
  });

  const { onSamlAppLogin } = useSamlAppLogin(orgId);

  if (billingMode === 'channel') {
    return (
      <>
        <RequestLicensesModal
          orgId={orgId}
          featureName={featureName}
          modalOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          packageId={packageId}
        />
        <OpInfo
          showIcon
          type={type}
          title={
            <div className="has-no-license-message">
              <span>{message}</span>
              <OpTextButton onClick={() => setModalOpen(true)}>
                {t('Request licenses')}
              </OpTextButton>
            </div>
          }
        />
      </>
    );
  }

  if (billingMode === 'revshare') {
    return (
      <OpInfo
        showIcon
        type={type}
        title={
          <div className="has-no-license-message">
            <span>{message}</span>
            <OpTextButton onClick={onSamlAppLogin}>
              {t('Purchase licenses')}
            </OpTextButton>
          </div>
        }
      />
    );
  }

  return null;
};
